import * as React from 'react';
import {
  Props, SameShopSpuData, SameShopSpuItem, State
} from './types';
import './index.css';

export default class MultiSpuLandscapeListView extends React.Component<Props, State> {
  itemLxReportListHistory = []
  onPendingItemLxReportList = []

  constructor(props: Props) {
    super(props);
  }

  checkHasItemLxReport = (item: any, index: number) => {
    const key = `${item.spuId}_${index}`;
    return Boolean(this.itemLxReportListHistory[key]);
  }

  markHasItemLxReport = (item: any, index: number) => {
    const key = `${item.spuId}_${index}`;
    this.itemLxReportListHistory[key] = true;
  }

  handleChangeSpuClick(sameSpuItem: SameShopSpuItem, index: number) {
    if (this.props.handleChangeSpuClick) {
      this.props.handleChangeSpuClick(sameSpuItem, index);
    }
  }

  handleReportSpuItemView = (item: SameShopSpuItem, index: number) => {
    if (this.props.handleReportSpuView) {
      this.props.handleReportSpuView(item, index);
    }
  }

  render() {
    const sameShopSpuData: SameShopSpuData = this.props.data || {};
    const selectedTips = sameShopSpuData?.selectedTips || '';
    const items = sameShopSpuData?.sameShopSpuList || [];
    return (
      <view className="container">
        <view className="container-content">
          <view className="container-content-top-bg-wrapper">
            <view className="container-content-top-bg-linear-gradient" />
          </view>
          <view className="content-scroller-warpper">
            <scroller
              className="content-scroller" showScrollIndicator={false} onScroll={(e) => {
                this.onPendingItemLxReportList.forEach((item: any) => {
                  if (this.checkHasItemLxReport(item.item, item.index)) {
                    return item;
                  }
                  if (item.x <= e.x + Mach.env.screenWidth) {
                    this.handleReportSpuItemView(item.item, item.index);
                    this.markHasItemLxReport(item.item, item.index);
                  }
                });
              }}
            >
              <content className="content-scroller-content">
                {items.map((item, index) => (
                  <view
                    className="content-item" key={index} style={{ marginLeft: index > 0 ? 8 : 0 }} onLayout={(e) => {
                      // 已经上报的不再上报
                      if (this.checkHasItemLxReport(item, index)) {
                        return;
                      }
                      if (e.detail.x <= Mach.env.screenWidth) {
                        // 已经展示在屏幕上的直接埋点上报
                        this.handleReportSpuItemView(item, index);
                        this.markHasItemLxReport(item, index);
                      } else {
                        // 还未展示在屏幕上的先缓存起来，等展示在屏幕上的时候再埋点上报
                        this.onPendingItemLxReportList.push({ item, index, x: e.detail.x });
                      }
                    }} onClick={() => {
                      this.handleChangeSpuClick(item, index);
                    }}
                  >
                    <view className="content-item-img-wrapper">
                      <image
                        className="content-item-img" resizeMode="aspectFill"
                        src={item.pictures[0] || 'assets://placeholder/icon_placeholder_1:1.png'}
                        placeholder="assets://placeholder/icon_placeholder_1:1.png"
                      />
                      {this.props.currentSpuId === item.spuId
                            && (
                              <view className="content-item-img-tag-wrapper">
                                <text className="content-item-selected-text" content={selectedTips} />
                              </view>
                            )}
                    </view>
                    <view className="content-item-product-content-wrapper">
                      <text className="content-item-product-text" content={item.name} />
                      <text className="content-item-price-text" content={item.discountPrice?.displayText} />
                    </view>
                  </view>
                ))}
              </content>
            </scroller>
          </view>
        </view>
      </view>
    );
  }
}
